// eslint-disable-next-line no-use-before-define
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import StyledEngineProvider from '@mui/material/StyledEngineProvider';
import { ThemedGlobalStyle } from 'theme';
import ThemeProvider from 'theme/ThemeProvider';
import { BrowserRouter } from 'react-router-dom';
import { WagmiProvider } from 'wagmi';

import { BigNumber } from 'bignumber.js';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import config from 'common-helpers/web3modalconfig';
import '@rainbow-me/rainbowkit/styles.css';
import { darkTheme, RainbowKitProvider } from '@rainbow-me/rainbowkit';
import { DefaultChainId } from 'constant';
import { ApolloMultiClientProvider } from './ApolloMultiClientProvider';
import { ModalProvider } from 'context/ModalContext';
import { ToastProvider } from 'context/ToastContext';
import { initToast } from 'utils/toast';
import { initializeGA } from 'utils/googleAnalytics';

BigNumber.set({ ROUNDING_MODE: BigNumber.ROUND_DOWN });

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

initializeGA();

initToast();

root.render(
    <Suspense fallback={<></>}>
        <WagmiProvider config={config}>
            <QueryClientProvider client={queryClient}>
                <RainbowKitProvider
                    initialChain={DefaultChainId}
                    showRecentTransactions={true}
                    modalSize="compact"
                    theme={darkTheme({
                        overlayBlur: 'small',
                        accentColor: '#F7931A',
                    })}
                    locale="en-US"
                >
                    <ApolloMultiClientProvider>
                        <StyledEngineProvider injectFirst>
                            <BrowserRouter>
                                <ThemeProvider>
                                    <ThemedGlobalStyle />
                                    <ModalProvider>
                                        <ToastProvider>
                                            <App />
                                        </ToastProvider>
                                    </ModalProvider>
                                </ThemeProvider>
                            </BrowserRouter>
                        </StyledEngineProvider>
                    </ApolloMultiClientProvider>
                </RainbowKitProvider>
            </QueryClientProvider>
        </WagmiProvider>
    </Suspense>,
);
